var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetryRecord = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M11.249 16.472q-1.488-.363-2.43-1.516a4.1 4.1 0 0 1-.944-2.668 4 4 0 0 1 .282-1.488q.282-.71.79-1.302a.41.41 0 0 1 .301-.14.44.44 0 0 1 .325.14q.126.12.13.292a.48.48 0 0 1-.12.325 3.3 3.3 0 0 0-.601 1.009q-.207.556-.207 1.164 0 1.19.747 2.119a3.54 3.54 0 0 0 1.913 1.232.46.46 0 0 1 .34.424.41.41 0 0 1-.155.34.4.4 0 0 1-.371.07Zm2.252.011a.4.4 0 0 1-.37-.073.426.426 0 0 1-.06-.6.5.5 0 0 1 .244-.166 3.8 3.8 0 0 0 1.91-1.255q.75-.915.75-2.1 0-1.444-1.05-2.454t-2.55-1.01h-.212l.493.475q.13.126.13.304a.44.44 0 0 1-.446.43.44.44 0 0 1-.316-.126l-1.196-1.15a.48.48 0 0 1-.154-.366.48.48 0 0 1 .153-.365l1.197-1.152a.44.44 0 0 1 .316-.125.44.44 0 0 1 .447.43.4.4 0 0 1-.13.304l-.494.475h.212q1.884 0 3.191 1.259 1.31 1.259 1.309 3.07 0 1.5-.946 2.656a4.53 4.53 0 0 1-2.428 1.54Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetryRecord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/retry-record.948e800c.svg";